import * as Common from '@/agiles/common';
import { ModelBinder } from '../common/modelBinder';

export class Favorite extends Common.ObjectBase{
    constructor(){
        super('Favorite');
    }
    public id: number = 0;
    public name: string = '';
    public viewName: string = '';    
    public path: string ='';
    public json: any = null;    
    public code: string = '';
    public icon: string= '';
    public iconColor:string='';
    public shared = '';
    public owner = '';
    public displayOrder: number;
    public displayOrderOnHome: number;    
    public showOnHome :boolean;
    public reportName :string;
    public get key() {
        return this.id == 0 ? this.code : this.id;
    }

    public get url (){

        if (this.path.indexOf('?') > -1) return this.path + '&favorite=' + this.key + '&static=1';
        else if (this.path) return this.path + '?favorite=' + this.key + '&static=1';
        else return '';
    }
    public count : number = null; //件数表示用のダミー

    public get isTenant() { return this.owner ? false : true;}
    public static perm= 'system.menu_tenant_setting.favorite'; //テナント共通の編集権限
}

export class FavoriteQuery extends Common.LoadQuery {
    constructor(flag:Common.favoriteFlags, path:string=''){
        super('FavoriteQuery',Favorite);
        this.flag = flag;
        this.path = path;
    }
    public flag : Common.favoriteFlags = Common.favoriteFlags.All;
    public path: string ='';
}

//一覧画面クエリ
export class FavoriteQuery2 extends Common.LoadQuery {
    constructor(){
        super('FavoriteQuery2',Favorite);
        this.sort = 'viewName';
    }
    public name:string;
    public viewName:string;
    public isAdmin:boolean = false;
}

export class FavoriteLoadQuery extends Common.Query {
    constructor(key:string){
        super('FavoriteLoadQuery',new Common.ModelBinder(Favorite,false));
        this.key = key;
    }
    public key: string='';
}

export class FavoriteProvisioningQuery extends Common.Query{
    constructor(){
        super('FavoriteProvisioningQuery', null);
    }    
}

export class DisplayOrderOnHomeUpdateQuery extends Common.Query {
  constructor(instance : Favorite, targetSeq: number){
    super("DisplayOrderOnHomeUpdateQuery", instance.binder); //ジェネリック型としてサーバーに転送。レスポンスバインダは不要
    this.instance = instance;
    this.targetSeq = targetSeq;
  }
  public instance : Favorite;
  public targetSeq  :number;
}
export class ReportFavoriteQuery extends Common.LoadQuery {
    constructor(){
        super('ReportFavoriteQuery',Favorite);
    }
}